export const GOOGLE_VERIFICATION_SETTING_PATH = '/site/verification/google';
export const YANDEX_VERIFICATION_SETTING_PATH = '/site/verification/yandex';

export const GSC_CONNECTION_METHOD = {
    AUTOMATIC: 'automatic',
    VERIFICATION_CODE: 'verification-code',
} as const;

export type GscConnectionMethod = (typeof GSC_CONNECTION_METHOD)[keyof typeof GSC_CONNECTION_METHOD];

export const SITE_NOT_PUBLISHED_GSC_GUARD = 'Опубликуйте сайт, чтобы подключить Google Search Console';
export const SITE_NOT_PUBLISHED_WEBMASTER_GUARD = 'Опубликуйте сайт, чтобы подключить Вебмастер';
